<div
  [class.category-item--opened]="item.state === accordionItemState.Opened"
  class="category-item"
>
  <div (click)="handleToggleItem(item)" class="category-item__trigger">
    <div class="category-item__name">{{ item.categoryName.value }}</div>
    <i class="category-item__trigger-icon icon"></i>
  </div>
  <div
    *ngIf="item.items.value.length"
    [@animation]="item.state"
    class="category-item__content"
  >
    <app-prices-table-category-items
      [items]="item.items.value"
    ></app-prices-table-category-items>
  </div>
</div>
